import { HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { EvaluationRepository } from '@app/domain/repositories/evaluation/evaluation.repository.contract';
import { ENV } from '@environments/environment';
import { SECTION_KEY } from '@services/interceptors/error-sections.interceptor/error-sections.interceptor';

import { MRepository } from '@mercadona/core/utils/repository-new';

import { EvaluationDetailDto, EvaluationDto } from '@/dtos/evaluation/evaluation.dto';
import { EvaluationFamilyType } from '@/enums/evaluation/evaluation.enum';
import { mapEvaluationDetail, mapEvaluationsData } from '@/mappers/evaluation/evaluation.mapper';
import { EvaluationDetail, EvaluationListItem } from '@/models/evaluation/evaluation.model';

const CACHE_KEYS = {
  EVALUATION_ID: Symbol('evaluation-id')
};

const TEN_MINUTES = 600000;

@Injectable({
  providedIn: 'root'
})
export class EvaluationRepositoryImpl extends MRepository implements EvaluationRepository {
  protected override readonly baseUrl = `${ENV.API_URL}`;

  getEvaluations(evaluationFamilyType: EvaluationFamilyType): Observable<EvaluationListItem[]> {
    let params = new HttpParams();
    params = params.set('type', evaluationFamilyType);

    return this.get<EvaluationDto>(`/evaluations`, {
      params,
      context: new HttpContext().set(SECTION_KEY, 'evaluations')
    }).pipe(map(mapEvaluationsData));
  }

  getEvaluationDetail(evaluationId: number): Observable<EvaluationDetail> {
    return this.get<EvaluationDetailDto>(
      `/evaluations/${evaluationId}`,
      {
        context: new HttpContext().set(SECTION_KEY, 'evaluations')
      },
      { key: `${CACHE_KEYS.EVALUATION_ID.description}-${evaluationId}`, expiry: TEN_MINUTES }
    ).pipe(map(mapEvaluationDetail));
  }
}
